import { HelpCircle } from 'lucide-react';

export default function FAQ() {
  const faqs = [
    {
      q: "هل الحضور المباشر إلزامي؟",
      a: "لا، يمكنك متابعة المحاضرات المسجلة في أي وقت، لكن الالتزام بتسليم التكاليف الأسبوعية في موعدها هو مفتاح نجاحك."
    },
    {
      q: "ما هي الأدوات المطلوبة؟",
      a: "برنامج Adobe Illustrator كأساسي، وAdobe Photoshop للموكابس."
    },
    {
      q: "كيف يتم التقييم؟",
      a: "التقييم يعتمد بنسبة 50% على المشروع النهائي و50% على المنطق والتطور خلال مراحل التنفيذ. لسنا هنا لتقييم \"الشكل\" بل \"الذكاء التصميمي\"."
    }
  ];

  return (
    <section id="faq" className="py-24 relative bg-slate-50 dark:bg-zinc-950 transition-colors duration-500 border-t border-slate-200 dark:border-white/5">
      <div className="container mx-auto px-4 z-10 relative">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-lg font-bold text-primary-600 dark:text-primary-500 mb-3 uppercase tracking-widest inline-flex items-center gap-2 transition-colors duration-500">
            <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
            استفساراتك مجابة
            <span className="w-8 h-1 bg-primary-500 rounded-full"></span>
          </h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white mb-6 leading-tight drop-shadow-sm dark:drop-shadow-lg transition-colors duration-500">
            الأسئلة <span className="text-transparent bg-clip-text bg-gradient-to-l from-primary-600 via-primary-500 to-primary-700 dark:from-primary-400 dark:via-primary-500 dark:to-primary-600">الشائعة</span>
          </h3>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {faqs.map((faq, idx) => (
            <div key={idx} className="bg-white/70 dark:bg-zinc-900/40 backdrop-blur-xl border border-slate-200 dark:border-white/10 rounded-lg p-8 hover:border-primary-500/50 dark:hover:border-primary-500/50 hover:bg-slate-100/90 dark:hover:bg-zinc-800/80 hover:-translate-y-2 transition-all duration-500 relative group overflow-hidden shadow-sm hover:shadow-lg dark:shadow-[0_10px_30px_rgba(0,0,0,0.3)]">
              <div className="absolute top-0 right-0 w-32 h-32 bg-primary-500/5 dark:bg-primary-500/10 rounded-full -mr-16 -mt-16 group-hover:scale-150 transition-all duration-700 ease-out blur-[30px] pointer-events-none"></div>

              <div className="relative z-10">
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-10 h-10 shrink-0 rounded-full bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 flex items-center justify-center group-hover:bg-primary-50 dark:group-hover:bg-primary-500/20 transition-colors duration-300">
                    <HelpCircle className="w-5 h-5 text-primary-600 dark:text-primary-500" />
                  </div>
                  <h4 className="text-lg font-bold text-slate-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors duration-500">{faq.q}</h4>
                </div>
                <p className="text-slate-600 dark:text-zinc-400 leading-relaxed font-medium transition-colors duration-500">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
